/**
 * Connection state.
 *
 * An accounting app that silently fails to save is worse than one that
 * says it cannot. The banner is persistent while offline rather than a
 * toast that disappears.
 */
import { useEffect, useState } from 'react'
import { Box, Typography } from '@mui/material'
import CloudOffIcon from '@mui/icons-material/CloudOff'
import { useTranslation } from 'react-i18next'
import { c } from '../theme'

export default function OfflineBanner() {
  const { t } = useTranslation()
  const [online, setOnline] = useState(navigator.onLine)

  useEffect(() => {
    const up = () => setOnline(true)
    const down = () => setOnline(false)
    window.addEventListener('online', up)
    window.addEventListener('offline', down)
    return () => {
      window.removeEventListener('online', up)
      window.removeEventListener('offline', down)
    }
  }, [])

  if (online) return null

  return (
    <Box sx={{
      position: 'sticky', top: 0, zIndex: 1250,
      bgcolor: c.dangerSoft, color: c.dangerInk,
      px: 2, py: 0.75, display: 'flex', alignItems: 'center', gap: 1,
    }}>
      <CloudOffIcon sx={{ fontSize: 17 }} />
      <Typography sx={{ fontSize: 12.5 }}>{t('pwa.offline')}</Typography>
    </Box>
  )
}
